export interface FooterContentSettings {
  title: string;
  description: string;
  instagramUrl: string;
  facebookUrl: string;
  eventsUrl: string;
  eventsLabel: string;
  copyrightLabel: string;
}

export const DEFAULT_FOOTER_CONTENT: FooterContentSettings = {
  title: 'Artisanal Vases',
  description: 'Handcrafted with sustainable materials. Coming soon.',
  instagramUrl: 'https://www.instagram.com/eco3dcor',
  facebookUrl: 'https://www.facebook.com/Eco3Dcor/',
  eventsUrl: '/events',
  eventsLabel: 'Events',
  copyrightLabel: 'Artisanal Vases. All rights reserved.',
};

function normalizeString(value: unknown, fallback: string) {
  return typeof value === 'string' && value.trim().length > 0 ? value.trim() : fallback;
}

export function resolveFooterContent(
  value: unknown,
  fallback: FooterContentSettings = DEFAULT_FOOTER_CONTENT
): FooterContentSettings {
  const raw = (value && typeof value === 'object' ? value : {}) as Record<string, unknown>;
  return {
    title: normalizeString(raw.title, fallback.title),
    description: normalizeString(raw.description, fallback.description),
    instagramUrl: normalizeString(raw.instagramUrl, fallback.instagramUrl),
    facebookUrl: normalizeString(raw.facebookUrl, fallback.facebookUrl),
    eventsUrl: normalizeString(raw.eventsUrl, fallback.eventsUrl),
    eventsLabel: normalizeString(raw.eventsLabel, fallback.eventsLabel),
    copyrightLabel: normalizeString(raw.copyrightLabel, fallback.copyrightLabel),
  };
}
